<template>
  <div id="concierge">
    <FormPremium v-if="template == 'Premium'" v-bind="$attrs" />
    <FormGroup v-else-if="template == 'Group'" v-bind="$attrs" />
    <FormOffsite v-else-if="template == 'Offsite'" v-bind="$attrs" />
    <Form v-else v-bind="$attrs" />
  </div>
</template>

<script setup>
import Form from "./TripNewConciergeForm.vue";
import FormPremium from "./TripNewConciergeFormPremium.vue";
import FormGroup from "./TripNewConciergeFormGroup.vue";
import FormOffsite from "./TripNewConciergeFormOffsite.vue";

defineProps({
  template: String,
});
</script>

<style lang="less">
#concierge {
  .checkboxlabel {
    margin-bottom: 0.5rem;
  }
}
</style>
